webpackJsonp([77],{

/***/ 1305:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1306);


/***/ }),

/***/ 1306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(169);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(793);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1305]);


// WEBPACK FOOTER //
// app/datetime.en-2bf1c112e0f3820505a5.js